import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  width?: number;
  height?: number;
  viewBox?: string;
}

const LocationIcon: FunctionComponent<Props> = ({
  className = "",
  width = 20,
  height = 20,
  viewBox = "0 0 20 20",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <title>Location</title>
      <path
        fill="inherit"
        fillRule="evenodd"
        d="M9.147 2.071c-2.526.445-4.383 2.97-4.123 5.607.205 2.075 1.774 5.166 4.344 8.555.32.422.604.767.632.767.061 0 1.052-1.295 1.626-2.126 1.997-2.89 3.175-5.42 3.35-7.196.197-1.993-.843-4.033-2.57-5.041-.942-.55-2.155-.76-3.26-.566Zm1.516 2.87c1.36.443 2.02 2.036 1.394 3.367-.39.833-1.155 1.325-2.057 1.325-1.152 0-2.08-.826-2.268-2.021-.272-1.719 1.342-3.19 2.93-2.671Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default LocationIcon;
